<template>
  <v-container grid-list-xl fluid>
    <template v-if="selected">
      <v-layout row wrap>
        <v-flex
          v-show="isSendType('push') && stats.push.length"
          xs12
          md6
          :offset-md3="!isSendType('email') || !stats.email.length"
          px-3
          text-xs-center
        >
          <div class="title">
            {{ $t('fields.notifications.sendTypes.push') }}
          </div>
          <div id="chartPush" />
        </v-flex>
        <v-flex
          v-show="isSendType('email') && stats.email.length"
          xs12
          md6
          :offset-md3="!isSendType('push') || !stats.push.length"
          px-3
          text-xs-center
        >
          <div class="title">
            {{ $t('fields.notifications.sendTypes.email') }}
          </div>
          <div id="chartEmail" />
        </v-flex>
      </v-layout>
    </template>
  </v-container>
</template>

<script>
import * as d3 from 'd3'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'TabStats',
  data() {
    return {
      interval: null,
    }
  },
  watch: {
    stats: {
      handler: function (val) {
        d3.select('#chartPush').html('')
        d3.select('#chartEmail').html('')
        if (val.push.length) {
          this.showStats('#chartPush', val.push)
        }
        if (val.email.length) {
          this.showStats('#chartEmail', val.email)
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.startInterval()
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  computed: {
    ...mapState({
      loading: (state) => state.notifications.loading,
      selected: (state) => state.notifications.selected,
    }),
    ...mapGetters({
      stats: 'notifications/stats',
    }),
  },
  methods: {
    ...mapActions({
      reset: 'notifications/reset',
      fetchStats: 'notifications/fetchStats',
    }),
    showStats(elementId, data) {
      const text = ''
      console.log('data :>> ', data)

      const width = 260
      const height = 260
      const thickness = 40
      // const duration = 750

      const radius = Math.min(width, height) / 2
      const color = d3.scaleOrdinal(d3.schemeCategory10)

      const svg = d3
        .select(elementId)
        .append('svg')
        .attr('class', 'pie')
        .attr('width', width)
        .attr('height', height)

      const g = svg
        .append('g')
        .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')')

      const arc = d3
        .arc()
        .innerRadius(radius - thickness)
        .outerRadius(radius)

      const pie = d3
        .pie()
        .value(function (d) {
          return d.value
        })
        .sort(null)

      g.selectAll('path')
        .data(pie(data))
        .enter()
        .append('g')
        .on('mouseover', function (d) {
          let g = d3
            .select(this)
            .style('cursor', 'pointer')
            .style('fill', 'black')
            .append('g')
            .attr('class', 'text-group')

          g.append('text')
            .attr('class', 'name-text')
            .text(`${d.data.name}`)
            .attr('text-anchor', 'middle')
            .attr('dy', '-1.2em')

          g.append('text')
            .attr('class', 'value-text')
            .text(`${d.data.value}`)
            .attr('text-anchor', 'middle')
            .attr('dy', '.6em')
        })
        .on('mouseout', function () {
          d3.select(this)
            .style('cursor', 'none')
            .style('fill', color(this._current))
            .select('.text-group')
            .remove()
        })
        .append('path')
        .attr('d', arc)
        .attr('fill', (d, i) => color(i))
        .on('mouseover', function () {
          d3.select(this).style('cursor', 'pointer').style('fill', 'black')
        })
        .on('mouseout', function () {
          d3.select(this)
            .style('cursor', 'none')
            .style('fill', color(this._current))
        })
        .each(function (d, i) {
          this._current = i
        })

      g.append('text')
        .attr('text-anchor', 'middle')
        .attr('dy', '.35em')
        .text(text)
    },
    fetchStatsNotification(id) {
      this.fetchStats(id)
    },
    isSendType(type) {
      return (
        this.selected &&
        this.selected.sendType &&
        this.selected.sendType.includes(type)
      )
    },
    startInterval() {
      this.interval = setInterval(() => {
        if (this.selected._id) {
          this.fetchStatsNotification(this.selected._id)
        }
      }, 60 * 1000)
    },
  },
}
</script>
<style>
.pie {
  margin: 20px;
}

.pie text {
  font-family: 'Verdana';
  fill: #888;
}

.pie .name-text {
  font-size: 1em;
}

.pie .value-text {
  font-size: 3em;
}
</style>
